/** F606 Clubs page — partner clubs / gym directory. */
import { Building2 } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606ClubsPage() {
  return (
    <F606DataPage
      entity="clubs"
      titleAr="الأندية"
      titleEn="Clubs"
      icon={Building2}
      emptyIcon={Building2}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        {
          key: 'name',
          ar: 'النادي', en: 'Club',
          render: (r) => (
            <div>
              <div className="font-bold text-white">{r.name || '—'}</div>
              {r.city && <div className="text-[10px] text-white/40">{r.city}{r.country ? `, ${r.country}` : ''}</div>}
            </div>
          ),
        },
        { key: 'members_count', ar: 'الأعضاء', en: 'Members', render: (r) => r.members_count ?? '—', className: 'w-20 text-center' },
        { key: 'rating', ar: 'التقييم', en: 'Rating', render: (r) => r.rating != null ? <span className="font-mono text-amber-300">{Number(r.rating).toFixed(1)} ★</span> : '—', className: 'w-20' },
        { key: 'phone', ar: 'الجوّال', en: 'Phone', render: (r) => <span className="font-mono text-[11px]" dir="ltr">{r.phone || '—'}</span> },
        {
          key: 'is_verified',
          ar: 'موثّق', en: 'Verified',
          render: (r) => (
            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold border ${
              r.is_verified ? 'bg-emerald-500/15 border-emerald-500/40 text-emerald-300' : 'bg-white/5 border-white/10 text-white/50'
            }`}>
              {r.is_verified ? '✓' : '—'}
            </span>
          ),
          className: 'w-24',
        },
      ]}
    />
  );
}
